<!-- GL Local Account Description Component -->
<div class="modal-header">
  <h3 class="modal-title">
    Local-Acct-Desc
    <i (click)="cancel()" class="fa fa-times pull-right"></i>
    <i class="fa pull-right" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px" 
       (click)="minimise=!minimise"></i>
  </h3>
</div>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    <li [class.active]="activeTab === 0">
      <a (click)="onTabChange(0)" style="cursor: pointer;" class="btn-sm">Local-Acct-Desc</a>
    </li>
    <li [class.active]="activeTab === 1">
      <a (click)="onTabChange(1)" style="cursor: pointer;" class="btn-sm">Audit</a>
    </li>
  </ul>

  <div class="tab-content">
    <!-- Local-Acct-Desc Tab -->
    @if (activeTab === 0) {
<div class="tab-pane active">
      <div class="col-md-12" style="padding: 15px;">
        <div class="divShadow">
          <form [formGroup]="localDescForm" name="localDescForm" id="screenFrom" class="form-horizontal" novalidate>
            @if (crudLoading) {
<div class="gt-filter-loading" style="text-align: center; padding: 20px;">
              <i style="color: #e12827;" class="fa fa-spinner fa-spin fa-3x"></i>
            </div>
}
            
            @if (!crudLoading) {
<div class="row">
              <div class="col-md-3">
                <label>Local Acct:</label>
                <input type="text" 
                       class="form-control" 
                       name="acctType" 
                       [value]="chartacct_data.localacct" 
                       readonly>
              </div>

              <div class="col-md-6">
                <label>Local Account Desc:</label>
                <textarea 
                  class="form-control input-sm" 
                  name="localAcountDescInput" 
                  formControlName="localAcountDescInput"
                  (input)="onInputChange($event)"
                  maxlength="100"
                  rows="3">
                </textarea>
                <br>
                @if (localAcountDescInput?.dirty && localAcountDescInput?.errors?.['required']) {
<span 
                      class="validation">
                  Local Account Desc is required!
                </span>
}
                @if (localAcountDescInput?.errors?.['maxlength']) {
<span 
                      class="validation">
                  Local Account Desc is too long!
                </span>
}
              </div>
            </div>
}
          </form>
        </div>
      </div>
    </div>
}

    <!-- Audit Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active">
      <div class="col-md-12" style="padding: 15px;">
        <div class="divShadow">
          <div class="table-responsive">
            @if (crudLoading) {
<div align="center" class="gt-filter-loading">
              <i style="color: #e12827;" class="fa fa-spinner fa-spin fa-3x"></i>
            </div>
}
            @if (!crudLoading) {
<div class="table-scroll">
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed sortable">
                <thead>
                  <tr>
                    @for (header of viewColumnNames; track $index; let i = $index) {
<th>
                      <i class="fa pr-5 pointer sticky-col" 
                         aria-hidden="true"
                         [ngClass]="{
                           'fa-sort': sort_key[i+1] == 0,
                           'fa-sort-alpha-asc': sort_key[i+1] == 1,
                           'fa-sort-alpha-desc': sort_key[i+1] == 2
                         }"
                         (click)="sortBy(i+1, sort_key[i+1])"></i>
                      {{ header }}
                    </th>
}
                  </tr>
                </thead>

                @if (noRecords) {
<tbody>
                  <tr>
                    <td class="loading-table" [attr.colspan]="viewColumnNames.length">
                      <div style="margin-top: 20px">
                        <b>No Data Available</b>
                      </div>
                    </td>
                  </tr>
                </tbody>
}

                @if (!noRecords) {
<tbody>
                  @for (t of getSortedAuditData(); track $index) {
<tr>
                    <td>{{ t.UPDATED_ON }}</td>
                    <td>{{ t.CHART }}</td>
                    <td>{{ t.LOCAL_ACCT_DESC }}</td>
                    <td>{{ t.DML_TYPE }}</td>
                    <td>{{ t.OLD_NEW_FLAG }}</td>
                    <td>{{ t.UPDATED_BY }}</td>
                  </tr>
}
                </tbody>
}
              </table>
            </div>
}
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" 
          type="button"
          (click)="save()" 
          [disabled]="localDescForm.invalid || crudLoading">
    @if (crudLoading) {
<span>
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
}
    Save
  </button>

  <button class="btn btn-danger-outline btn-sm" 
          type="button"
          (click)="reset()">
    Reset
  </button>
  
  <button class="btn btn-warning btn-sm" 
          type="button"
          (click)="cancel()">
    Cancel
  </button>
</div>

